// ═══ v2 상단 메뉴 + 그룹 탭 (BRIEF D3) ═══
// id 는 v1 라우트 id 그대로 — URL 전부 보존. Dashboard.js 의 MENUS 와 같은 모양([{section, items:[{id,label}]}]) 이라
// 기존 필터(면장 수신함 파일럿·미가동 메뉴·경매 플래그)와 렌더러가 그대로 돈다.
// '수출서류' 는 네비에 **항목 1개**(smart-upload)만 둔다 — 면장 수신함은 화면 안 로컬 탭(v2/docs/DocsTabs.js)이 그리므로
// 네비 드롭다운이 필요 없고, 두면 타이틀('면장 수신함')과 헤더 탭('면장 수신함')이 같은 단어를 두 번 보여준다.
export var V2_MENUS = [
  { section: '메인', items: [{ id: 'dashboard', label: '대시보드' }] },
  { section: '차량', items: [{ id: 'car-list', label: '차량' }] },
  { section: '인보이스', items: [{ id: 'invoice', label: '인보이스' }] },
  { section: '수출서류', items: [{ id: 'smart-upload', label: '수출서류' }] },
  { section: '세무·장부', items: [{ id: 'tax', label: '세무·장부' }] },
  { section: '바이어', items: [{ id: 'buyers', label: '바이어' }] },
  { section: '차량 평가', items: [{ id: 'eval', label: '차량 평가' }] },
  { section: '시스템', items: [{ id: 'settings', label: '설정' }] }
];

// 메뉴에서 빠지고 헤더 탭으로 흡수된 화면. 첫 항목이 그룹의 대표(네비 활성 id).
export var GROUP_TABS = {
  cars: [
    { id: 'car-list', label: '목록' },
    { id: 'car-register', label: '등록' },
    { id: 'cancel-tracking', label: '말소 진행' },
    { id: 'cancel-doc-requests', label: '보강서류', badgeKey: 'cancelDocCount' }
  ],
  tax: [
    { id: 'tax', label: '세무처리' },
    { id: 'tax-invoice', label: '세금계산서' },
    { id: 'ledger', label: '장부' }
  ]
};
export var GROUP_TITLE = { cars: '차량', tax: '세무·장부' };

// GROUP_TABS 는 아니지만 한 네비 항목으로 접히는 화면 — id → 대표 메뉴 id.
// 수출서류(문서 업로드 | 면장 수신함)는 화면 로컬 탭이라 GROUP_TABS 에 넣지 않는다(useGroupTabs 대상 아님).
export var NAV_ALIAS = { 'myunjang-queue': 'smart-upload' };

// 화면 id → 그룹 id ('cars' | 'tax' | '')
export function groupOf(id) {
  var g = Object.keys(GROUP_TABS);
  for (var i = 0; i < g.length; i++) {
    for (var j = 0; j < GROUP_TABS[g[i]].length; j++) if (GROUP_TABS[g[i]][j].id === id) return g[i];
  }
  return '';
}

// 화면 id → 네비에서 활성으로 켤 메뉴 id (그룹 하위 화면은 대표 항목, 별칭은 NAV_ALIAS)
export function navIdOf(id) {
  var g = groupOf(id);
  if (g) return GROUP_TABS[g][0].id;
  return NAV_ALIAS[id] || id;
}

// 화면 id → 헤더 타이틀. 메뉴 목록이 아니라 **id 로만** 정해진다 —
// 파일럿 게이트·회사 목록 도착 지연으로 메뉴에서 항목이 빠져도 타이틀이 흔들리면 안 된다(직접 진입/새로고침).
var TITLE_BY_ID = (function () {
  var m = {};
  V2_MENUS.forEach(function (s) { s.items.forEach(function (i) { m[i.id] = i.label; }); });
  Object.keys(GROUP_TABS).forEach(function (g) { GROUP_TABS[g].forEach(function (t) { m[t.id] = GROUP_TITLE[g]; }); });
  Object.keys(NAV_ALIAS).forEach(function (id) { m[id] = m[NAV_ALIAS[id]]; });
  return m;
})();
export function v2Title(id, fallbackLabel) {
  return TITLE_BY_ID[id] || fallbackLabel || '대시보드';
}

// ═══ 관리자 v2 메뉴 (ADMIN.md S6) ═══
// 라벨은 v1 ROLE_MENUS['관리자'] 원문 그대로(웹-앱 용어 일치). URL(id) 도 전부 보존.
// '차량'·'세무·장부' 는 수출업체 v2 와 같은 그룹(GROUP_TABS) — 하위 화면은 헤더 탭으로 연다.
// admin 전용 화면(업체 관리·관리자·신고함…)은 v2 화면이 없다 — Dashboard.js 가 v1 컴포넌트를 슬림 셸 안에 그대로 렌더한다.
export var V2_ADMIN_MENUS = [
  { section: '메인', items: [{ id: 'dashboard', label: '대시보드' }] },
  { section: '차량', items: [{ id: 'car-list', label: '차량' }] },
  { section: '인보이스', items: [{ id: 'invoice', label: '인보이스' }] },
  { section: '수출서류', items: [
    { id: 'smart-upload', label: '문서 업로드' },
    { id: 'myunjang-queue', label: '면장 수신함' },
    { id: 'bulk-cancel-upload', label: '대량 말소증' }
  ] },
  { section: '세무·장부', items: [{ id: 'tax', label: '세무·장부' }] },
  { section: '바이어', items: [
    { id: 'buyers', label: '바이어' },
    { id: 'rfq', label: 'PROMISE 출품' },
    { id: 'inquiries', label: '매물 문의' },
    { id: 'transactions-confirm', label: '거래 완료 확인' },
    { id: 'cart-payments', label: '혼적 입금확인' }
  ] },
  { section: '차량 평가', items: [{ id: 'eval', label: '차량 평가' }] },
  { section: '협력사', items: [
    { id: 'companies', label: '업체 관리' },
    { id: 'cancel-agency', label: '대행업체 관리' },
    { id: 'clearance-admin', label: '관세사 관리' },
    { id: 'carrier-admin', label: '캐리어 관리' },
    { id: 'shoring-admin', label: '쇼링장 관리' },
    { id: 'dispatch-admin', label: '배차 관리' },
    { id: 'clearance-queue', label: '면장 대기열' }
  ] },
  { section: '시스템', items: [
    { id: 'admin-overview', label: '전체 현황' },
    { id: 'bug-reports', label: '신고함' },
    { id: 'admin-disputes', label: '거래 분쟁 검토' },
    // 푸시 발송은 '계정 관리' **앞** 에 넣는다 — 계정 관리↔관리자 두 줄이 붙어 있어야 한다는 기대를
    //   tests/admin-accounts-web.test.js:585 가 정규식으로 고정해 두었다. 그 사이에 끼우면 깨진다.
    { id: 'admin-push', label: '푸시 발송' },
    { id: 'admin-accounts', label: '계정 관리 (테스트)' },
    { id: 'admin', label: '관리자' },
    { id: 'settings', label: '설정' }
  ] }
];

// admin 타이틀 — 메뉴가 항목을 개별 노출하므로 NAV_ALIAS(면장 수신함 → 수출서류) 접기를 쓰지 않는다.
var ADMIN_TITLE_BY_ID = (function () {
  var m = {};
  V2_ADMIN_MENUS.forEach(function (s) { s.items.forEach(function (i) { m[i.id] = i.label; }); });
  Object.keys(GROUP_TABS).forEach(function (g) { GROUP_TABS[g].forEach(function (t) { m[t.id] = GROUP_TITLE[g]; }); });
  return m;
})();
export function v2AdminTitle(id, fallbackLabel) {
  return ADMIN_TITLE_BY_ID[id] || fallbackLabel || '대시보드';
}
// admin 네비 활성 id — 그룹 하위 화면만 대표 항목으로 접는다(별칭 없음).
export function navIdOfAdmin(id) {
  var g = groupOf(id);
  return g ? GROUP_TABS[g][0].id : id;
}

// ═══ 서류대행(doc_agency) v2 메뉴 (roles-redesign/A-docagency.md A1·A4) ═══
// 수출업체 V2_MENUS 8개 그대로 + '협력사 › 업체 관리'(A1) + '바이어' 드롭다운 4개(A4).
// 라벨은 v1 ROLE_MENUS['doc_agency'] 원문 그대로(웹-앱 용어 일치), id(URL) 도 전부 보존.
// '관세사 보완요청'·'관세사 메시지' 는 메뉴에서 빠지고 수출서류 화면의 로컬 탭으로 흡수된다(A1).
// 바이어 4항목은 Dashboard.js 의 UNRELEASED_MENU_IDS 게이트가 admin 이 아니면 걸러낸다 — 메뉴엔 두고 게이트에 맡긴다.
export var V2_DOC_AGENCY_MENUS = [
  { section: '메인', items: [{ id: 'dashboard', label: '대시보드' }] },
  { section: '차량', items: [{ id: 'car-list', label: '차량' }] },
  { section: '인보이스', items: [{ id: 'invoice', label: '인보이스' }] },
  { section: '수출서류', items: [{ id: 'smart-upload', label: '수출서류' }] },
  { section: '세무·장부', items: [{ id: 'tax', label: '세무·장부' }] },
  { section: '바이어', items: [
    { id: 'buyers', label: '바이어' },
    { id: 'rfq', label: 'PROMISE 출품' },
    { id: 'inquiries', label: '매물 문의' },
    { id: 'transactions-confirm', label: '거래 완료 확인' },
    { id: 'cart-payments', label: '혼적 입금확인' }
  ] },
  { section: '차량 평가', items: [{ id: 'eval', label: '차량 평가' }] },
  { section: '협력사', items: [{ id: 'companies', label: '업체 관리' }] },
  { section: '시스템', items: [{ id: 'settings', label: '설정' }] }
];

// 서류대행 별칭 — '수출서류' 하나로 접히는 화면들(면장 수신함 + 관세사 보완요청/메시지 = 화면 로컬 탭).
// 공용 NAV_ALIAS 를 넘보지 않고 따로 둔 이유: NAV_ALIAS 는 V2_HIDDEN_ITEMS·v2Title 의 입력이라
// 항목을 보킬면 수출업체·관리자의 기존 결과가 바뀜다(v2-kit.test.js 가 그 배열을 전수 고정).
var DOC_NAV_ALIAS = { 'myunjang-queue': 'smart-upload', 'clearance-revisions': 'smart-upload', 'clearance-messages': 'smart-upload' };

// 서류대행 타이틀 — 그룹(차량·세무·장부)은 공용 GROUP_TABS, 별칭은 DOC_NAV_ALIAS.
var DOC_TITLE_BY_ID = (function () {
  var m = {};
  V2_DOC_AGENCY_MENUS.forEach(function (s) { s.items.forEach(function (i) { m[i.id] = i.label; }); });
  Object.keys(GROUP_TABS).forEach(function (g) { GROUP_TABS[g].forEach(function (t) { m[t.id] = GROUP_TITLE[g]; }); });
  Object.keys(DOC_NAV_ALIAS).forEach(function (id) { m[id] = m[DOC_NAV_ALIAS[id]]; });
  return m;
})();
export function v2DocAgencyTitle(id, fallbackLabel) {
  return DOC_TITLE_BY_ID[id] || fallbackLabel || '대시보드';
}
// 서류대행 네비 활성 id — 그룹 하위 화면은 대표 항목, 별칭은 수출서류.
// 바이어 드롭다운 4항목은 메뉴에 개별 노출되므로 접지 않는다.
export function navIdOfDocAgency(id) {
  var g = groupOf(id);
  if (g) return GROUP_TABS[g][0].id;
  return DOC_NAV_ALIAS[id] || id;
}

// ═══ 운영 관리자(operator) v2 메뉴 ═══
// 업무 6개를 각각 URL 로 가른다 — 1차 콘솔은 화면 1개 안의 5탭이라 새로고침/북마크가 늘 첫 탭으로 돌아갔다.
// id 를 'operator-' 로 네임스페이스한 이유: 같은 이름(companies·bug-reports)의 어드민 화면과 라우트·타이틀이
// 섞이면 안 된다. operator 는 **업체 데이터 화면이 하나도 없는** 별도 라우트 표라(Dashboard.js),
// 어드민 id 를 재사용하면 주소창으로 어드민 화면에 닿는 길이 생긴다.
// 라벨은 v1 콘솔 탭 이름 그대로(운영자 용어 유지). 그룹(GROUP_TABS)·별칭(NAV_ALIAS)은 쓰지 않는다 — 6개 다 평면.
export var V2_OPERATOR_MENUS = [
  { section: '전체 현황', items: [{ id: 'operator-overview', label: '전체 현황' }] },
  // 업체/계정 관리 = 마스터용 통합 화면을 그대로 쓴다. **id 가 admin-accounts 여야 한다** —
  //   그 화면은 유형을 고를 때 자기 경로(/main/admin-accounts?kind=…)로 navigate 하는데
  //   경로가 다르면 operator 의 catch-all 이 전체 현황으로 되돌려 내비가 먹통이 된다.
  // 별도였던 '업체 관리'(v2/operator/companies)는 이 화면의 수출업체·서류대행·위탁사 유형과
  //   같은 것을 두 번 보여주고 있어 흡수했다 (2026-09-30, Jin). 업체 등록·사업자등록증 심사도 함께 옮겼다.
  { section: '업체/계정 관리', items: [{ id: 'admin-accounts', label: '업체/계정 관리' }] },
  { section: '공지', items: [{ id: 'operator-notices', label: '공지' }] },
  // 푸시 발송 = 마스터용 화면(v2/admin/push)을 그대로 쓴다. 공지(게시판)와 **별개 기능**이다 —
  //   게시판은 앱에서 열어 봐야 하고, 이쪽은 앱 알림함 + 휴대폰 알림으로 밀어 준다.
  //   id 가 admin-push 여야 한다(라우트 표·허용 목록이 그 경로로 열려 있다).
  { section: '푸시 발송', items: [{ id: 'admin-push', label: '푸시 발송' }] },
  { section: '시스템', items: [{ id: 'operator-system', label: '시스템' }] },
  { section: '신고함', items: [{ id: 'operator-bugs', label: '신고함' }] },
  // 본인 비밀번호 변경만. 업체용 설정 전체를 붙이면 대부분 403 이라 별도 화면을 쓴다.
  { section: '설정', items: [{ id: 'operator-settings', label: '설정' }] }
];

// 운영 관리자 타이틀 — 메뉴 id 로만 정해진다(다른 role 과 동일 규칙).
var OPERATOR_TITLE_BY_ID = (function () {
  var m = {};
  V2_OPERATOR_MENUS.forEach(function (s) { s.items.forEach(function (i) { m[i.id] = i.label; }); });
  return m;
})();
export function v2OperatorTitle(id, fallbackLabel) {
  return OPERATOR_TITLE_BY_ID[id] || fallbackLabel || '전체 현황';
}

// Dashboard.js 의 ai(전 항목 목록)에 보태는 숨은 항목 — 네비에 없는 화면이 URL 로 열릴 때 am/openTabs 가 잡히게.
export var V2_HIDDEN_ITEMS = (function () {
  var out = [];
  Object.keys(GROUP_TABS).forEach(function (g) {
    GROUP_TABS[g].forEach(function (t, i) { if (i > 0) out.push({ id: t.id, label: GROUP_TITLE[g] }); });
  });
  Object.keys(NAV_ALIAS).forEach(function (id) { out.push({ id: id, label: TITLE_BY_ID[id] }); });
  return out;
})();
